import { render, staticRenderFns } from "./UnbindModal.vue?vue&type=template&id=aceafbae&scoped=true"
import script from "./UnbindModal.vue?vue&type=script&lang=js"
export * from "./UnbindModal.vue?vue&type=script&lang=js"
import style0 from "./UnbindModal.vue?vue&type=style&index=0&id=aceafbae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceafbae",
  null
  
)

export default component.exports